/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { uniqueId } from 'lodash';
import { useHistory } from 'react-router-dom';
import { showNotification } from '../../actions/Notification/notificationActions';
import {
    ticketsSpam,
    ticketsPrivate,
    ticketsClose,
    ticketsDelete
} from '../../actions/Tickets/ticketsActions';
import MenuList from '../../assets/svgs/MenuList';
import MinusCircle from '../../assets/svgs/MinusCircle';
import Lock from '../../assets/svgs/Lock';
import Cross from '../../assets/svgs/Cross';
import Trash from '../../assets/svgs/Trash';

const TicketItem = ({ className, ticket, isSpam, isPrivate, isClose }) => {
    const [showTooltip, setToolTip] = useState(false);
    const toolTipEl = useRef(null);
    const toolTipButtonEl = useRef(null);
    const dispatch = useDispatch();
    const history = useHistory();

    const statusHandler = async status => {
        setToolTip(false);

        switch (status) {
            case 'spam':
            case 'unspam':
                await dispatch(ticketsSpam(ticket.id, status));
                break;
            case 'private':
            case 'unprivate':
                await dispatch(ticketsPrivate(ticket.id, status));
                break;
            case 'close':
            case 'open':
                await dispatch(ticketsClose(ticket.id, status));
                break;
            case 'delete':
                if (window.confirm('آیا مطمئن هستید؟')) {
                    dispatch(ticketsDelete(ticket.id));
                }
                break;
            default:
                return false;
        }

        await dispatch(
            showNotification({
                id: uniqueId('error-'),
                type: 'success',
                text: 'عملیات با موفقیت انجام شد.'
            })
        );
    };

    const tooltipHandler = () => {
        setToolTip(!showTooltip);
    };

    const onClickHandler = event => {
        if (
            toolTipButtonEl.current.contains(event.target) ||
            toolTipEl.current.contains(event.target)
        ) {
            return;
        }
        setToolTip(false);
        history.push({
            pathname: `ticket/${ticket.id}`,
            ticket
        });
    };

    return (
        <div className={className} onClick={onClickHandler}>
            <div className="TicketItem__Info">
                <h3>{ticket.name}</h3>
                <span>{ticket.cat}</span>
            </div>
            <div className="TicketItem__Meta">
                <div
                    className={`TicketItem__ActionList ${
                        showTooltip ? 'isOpen' : ''
                    }`}
                    ref={toolTipEl}
                >
                    <button
                        type="button"
                        onClick={() =>
                            statusHandler(!isSpam ? 'spam' : 'unspam')
                        }
                    >
                        <MinusCircle />
                        {!isSpam ? 'اسپم' : 'غیراسپم'}
                    </button>
                    <button
                        type="button"
                        onClick={() =>
                            statusHandler(!isPrivate ? 'private' : 'unprivate')
                        }
                    >
                        <Lock />
                        {!isPrivate ? 'خصوصی' : 'غیرخصوصی'}
                    </button>
                    <button
                        type="button"
                        onClick={() =>
                            statusHandler(!isClose ? 'close' : 'open')
                        }
                    >
                        <Cross />
                        {!isClose ? 'بستن' : 'بازکردن'}
                    </button>
                    <button
                        type="button"
                        onClick={() => statusHandler('delete')}
                    >
                        <Trash />
                        حذف کردن
                    </button>
                </div>

                <button
                    type="button"
                    onClick={tooltipHandler}
                    ref={toolTipButtonEl}
                >
                    <MenuList />
                </button>
                <span>{`${ticket.date} پیش`}</span>
            </div>
        </div>
    );
};

TicketItem.propTypes = {
    className: PropTypes.string.isRequired,
    ticket: PropTypes.any.isRequired,
    isSpam: PropTypes.bool.isRequired,
    isPrivate: PropTypes.bool.isRequired,
    isClose: PropTypes.bool.isRequired
};

export default styled(TicketItem)`
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    background: #ffffff;
    padding: 10px 16px;
    margin-bottom: 16px;
    border-radius: 5px;
    box-shadow: 0 2px 4px rgba(100, 106, 147, 0.05);
    cursor: pointer;

    &:last-of-type {
        margin-bottom: 32px;
    }

    .TicketItem__Info {
        h3 {
            font-size: 14px;
            line-height: 25px;
            font-weight: bold;
            color: #0d1fa1;
            margin-bottom: 5px;
        }

        span {
            font-size: 12px;
            line-height: 21px;
            font-weight: 400;
            color: #a2a4b5;
        }
    }

    .TicketItem__Meta {
        position: relative;
        display: flex;
        flex-flow: column;
        align-items: flex-end;
        justify-content: space-between;

        > button {
            position: relative;
            padding: 5px;
            background: transparent;
            box-shadow: none;
            border: none;
        }

        > span {
            font-size: 10px;
            line-height: 17px;
            font-weight: 400;
            color: #cccccc;
        }
    }

    .TicketItem__ActionList {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 105px;
        position: absolute;
        left: 16px;
        bottom: 4px;
        background: #f7f7f7;
        padding: 12px;
        opacity: 0;
        visibility: hidden;
        transition: opacity 300ms ease-out;

        &.isOpen {
            opacity: 1;
            visibility: visible;
        }

        button {
            width: 100%;
            background: transparent;
            box-shadow: none;
            border: none;
            font-size: 10px;
            line-height: 17px;
            font-weight: 400;
            color: #000946;
            padding: 7px 0px;
            text-align: right;

            > svg {
                margin-left: 10px;
            }

            &:first-child {
                padding-top: 0;
            }

            &:last-child {
                color: #ff2727;
                padding-bottom: 0;
            }
        }
    }
`;
